import React from 'react'
import Navbar from '../shared/Navbar'
import TittleBanner from '../shared/TittleBanner'
import ContactForm from '../shared/ContactForm'
import Footer from '../Footer/footer'

export default function Contact() {
  return (
    <div>
      <Navbar/>
      <TittleBanner tiitle="contact" img="bg-about-us-banner"/>
      <ContactForm/>
      <Footer/>
    </div>
  )
}
